// src/hooks/useUserData.js
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { createApi } from '../lib/api';

/**
 * Loads user data from Worker API (Replaces Firestore snapshot).
 */
export function useUserData() {
  const { user, uid, getToken, authReady } = useAuth();
  const [data, setData] = useState({
    credits: 0,
    partnerStatus: 'loading',
    partnerSlug: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authReady) return;
    if (!uid) {
        setData({ credits: 0, partnerStatus: 'none', partnerSlug: null });
        setLoading(false);
        return;
    }

    let mounted = true;

    const fetchMe = async () => {
       try {
         const api = createApi(getToken);
         const res = await api.get('/user/me');
         
         if (mounted && res.ok && res.user) {
            let pStatus = 'none';
            let pSlug = null;
            
            // If user is flagged as partner, we might want to fetch slug if not provided.
            // For this migration pass, we ensure basic credits work.
            if (res.user.isPartner) {
                pStatus = 'active'; 
            }
            
            setData({
                credits: res.user.credits || 0,
                partnerStatus: pStatus,
                partnerSlug: pSlug
            });
         }
       } catch(e) {
         console.error('useUserData fetch error', e);
       } finally {
         if (mounted) setLoading(false);
       }
    };

    fetchMe();

    return () => { mounted = false; };
  }, [uid, authReady, getToken]);

  return { user, loading, ...data };
}
